import { useState } from "react";
import { LockKeyhole, ShieldCheck } from "lucide-react";
import { api } from "../lib/api";
import { ErrorMessage } from "./Loading";

export default function MemberGate({ onSuccess, compact = false }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [individualAccount, setIndividualAccount] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function submit(event) {
    event.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await api("/api/login", { method: "POST", body: JSON.stringify({ email: individualAccount ? email : "", password }) });
      setPassword("");
      onSuccess?.();
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setSubmitting(false);
    }
  }

  const Heading = compact ? "h2" : "h1";

  return (
    <section className={compact ? "member-gate is-compact" : "member-gate"}>
      <div className="member-gate__icon"><LockKeyhole aria-hidden="true" /></div>
      <div>
        <p className="kicker">For classmates and families</p>
        <Heading>{compact ? "Sign in to open this album" : "Come into the member room"}</Heading>
        <p>
          {individualAccount
            ? "Use your individual class account to update your record and see member-only photographs."
            : "Use the shared class passphrase for read-only access to member details, photographs, and reunion albums."}
        </p>
      </div>
      <form onSubmit={submit} className="member-gate__form">
        <div className="member-gate__fields">
          {individualAccount && <label htmlFor={compact ? "album-email" : "member-email"}>
            Login email
            <input
              id={compact ? "album-email" : "member-email"}
              type="email"
              autoComplete="username"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
          </label>}
          <label htmlFor={compact ? "album-password" : "member-password"}>
            {individualAccount ? "Password" : "Class passphrase"}
          <input
            id={compact ? "album-password" : "member-password"}
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
          </label>
        </div>
        <div className="member-gate__actions">
          <button className="button button--ink" disabled={submitting} type="submit">
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </div>
        {error && <ErrorMessage>{error}</ErrorMessage>}
        <p className="privacy-note"><ShieldCheck aria-hidden="true" /> The passphrase stays on the server, and your session stays in a secure, HttpOnly cookie.</p>
        <button className="text-link member-gate__setup" type="button" onClick={() => { setIndividualAccount((value) => !value); setError(""); }}>{individualAccount ? "Use the shared class passphrase" : "Use an individual account"}</button>
      </form>
    </section>
  );
}
